import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ChevronRight, ChevronDown, Users, Search } from 'lucide-react';

const TreeNode = ({ node, depth = 0 }) => {
  const [open, setOpen] = useState(depth < 2);
  const hasChildren = node.children?.length > 0;

  return (
    <div className="ml-4">
      <div
        className="flex items-center gap-2 py-1 hover:bg-gray-50 rounded cursor-pointer"
        onClick={() => hasChildren && setOpen(!open)}
      >
        {hasChildren ? (
          open ? <ChevronDown className="w-4 h-4 text-gray-400" /> : <ChevronRight className="w-4 h-4 text-gray-400" />
        ) : (
          <span className="w-4" />
        )}
        <Users className="w-4 h-4 text-blue-500" />
        <span className="font-medium text-gray-800">{node.name}</span>
        <span className="text-xs text-gray-500">({node.emp_code})</span>
        <span className="text-xs bg-gray-100 px-2 py-0.5 rounded">{node.role || node.designation}</span>
        {node.department && <span className="text-xs text-gray-400">{node.department}</span>}
      </div>
      {open && hasChildren && node.children.map((c) => <TreeNode key={c.id} node={c} depth={depth + 1} />)}
    </div>
  );
};

const HierarchyTreeView = ({ departmentId }) => {
  const [tree, setTree] = useState(null);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = departmentId ? { department_id: departmentId } : {};
    axios.get('/v1/employee-master/hierarchy/tree', { params })
      .then((r) => setTree(r.data))
      .finally(() => setLoading(false));
  }, [departmentId]);

  if (loading) return <p className="text-gray-500 p-4">Loading hierarchy…</p>;
  if (!tree) return <p className="text-gray-500 p-4">Unable to load hierarchy.</p>;

  const filteredRoots = filter
    ? tree.roots.filter((n) => JSON.stringify(n).toLowerCase().includes(filter.toLowerCase()))
    : tree.roots;

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-gray-900">Organization Hierarchy</h3>
        <span className="text-sm text-gray-500">{tree.total_employees} employees</span>
      </div>
      <div className="relative mb-4">
        <Search className="w-4 h-4 absolute left-3 top-2.5 text-gray-400" />
        <input
          type="text"
          placeholder="Search in tree…"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="w-full pl-9 pr-3 py-2 border rounded-lg text-sm"
        />
      </div>
      <div className="max-h-96 overflow-y-auto border rounded-lg p-2">
        {filteredRoots.length === 0 ? (
          <p className="text-gray-500 text-sm p-2">No nodes match search.</p>
        ) : (
          filteredRoots.map((n) => <TreeNode key={n.id} node={n} depth={0} />)
        )}
      </div>
    </div>
  );
};

export default HierarchyTreeView;
